import { ref } from 'vue';
import { RegimeTributarioEnumerator, ResponsavelTecnicoEnumerator } from '@/enums/configuracao';
import FilialService from './service';

function initFilial() {
  return {
    codigo: 0,
    nome: '',
    priorizarCodigo: '',
    cidade: '',
    uf: '',
    razao: '',
    endereco: '',
    numero: '',
    complemento: '',
    bairro: '',
    cnpj: '',
    inscricaoEstadual: '',
    telefone: '',
    telefone2: '',
    emailComercial: '',
    fusoHorario: -3,
    timeoutEnvioNota: 9999,
    modoEnvioNfe: 0,
    nfceSerie: 0,
    nfCeModelo: 0,
    nfCeNumero: 0,
    nfceAmbiente: 1,
    nfceCodSeq: 0,
    nfceToken: '',
    nfceTamQrCode: 96,
    nfeSerie: 0,
    nfeModelo: 0,
    nfeNumero: 0,
    nfeAmbiente: 0,
    nomeContador: '',
    cpfContador: '',
    cnpjContador: '',
    crcContador: '',
    cepContador: '',
    enderecoContador: '',
    numeroContador: '',
    complementoContador: '',
    bairroContador: '',
    telefoneContador: '',
    emailContador: '',
    cidadeContador: '',
    ufContador: '',
    regimeTributario: RegimeTributarioEnumerator.Simples.valueEnum,
    bridgeless: false,
    mdfeAmbiente: 2,
    responsavelTipo: ResponsavelTecnicoEnumerator.None.valueEnum,
    responsavelCnpj: '',
    responsavelNome: '',
    responsavelEmail: '',
    responsavelFone: '',
    responsavelIdCsrt: 0,
    responsavelCsrt: '',
    carencia: 0,
    juros: 0,
    multa: 0,
    desconto: 0,
    logo: '',
    eixoHorizontalGrade: 0,
    diaUtilSabado: true,
    diaUtilDomingo: true,
    inativo: false,
    tokenConsultaClienteApi: '',
    nfeUltimoNsu: 0,
    regApTribSN: 0,
    regEspTrib: 0,
    nfseSerie: 0,
    nfseNumero: 0,
    nfseAmbiente: 0,
    nfseDps: 0,
    inscricaoMunicipal: '',
  };
}

const props = ref({
  filial: initFilial(),
  filialLoading: false,
  logoBase64: '', // Logo em base64 para envio
  isPreviousPageDisabled: false,
  isNextPageDisabled: false,
  take: 10,
  skip: 0,
  tableData: {
    data: [],
  },
  filialForm: initFilial(),
});

function setFilial(value) {
  props.value.filial = value;
  props.value.filialLoading = true;
}

async function fillFilial(filial) {
  await FilialService.get(filial).then((data) => {
    setFilial(data);
  });
}

const dadosVrRespTec = ref({
  nome: 'VR SYSTEM TECNOLOGIA EIRELI',
  cnpj: '05384914000117',
  email: 'suporte@vrsystem.info',
  fone: '2433433737',
});

function isBridgeless() {
  return props.value.filial.bridgeless;
}

export { setFilial, props, FilialService, fillFilial, dadosVrRespTec, isBridgeless, initFilial };
